import React, { useState, useEffect } from "react";
import {
  LoginInputField,
  RequestOtpBtn,
  CheckBoxIonInput,
  SelectList,
  RangeInput,
  IonRange,
  valueRangeMaxMin,
  mtCustomerSubscribeToPayload,
  replaceStrThaiEngWithSpace,
  mtCustomerSubscribeRequestToPayload,
} from "./Common";
import { unitToValue, postApiDataAsync, kloader } from "../common/Common";
import { useSelector, useDispatch } from "react-redux";
import classnames from "classnames/bind";
import {
  ClearCusInfo,
  formsCusInfoDataChange,
  ClearSearchCriteria,
  fillFromObjCriteriaList,
  searchCriteriaValidateChange,
  searchCriteriaValidate,
  removeObjInCriteriaList,
  addObjToCriteriaList,
  searchCriteriaDataChange,
  searchCriteriaListChange,
  searchCriteriaIonRangeChange,
  updateCriteriaIonRange,
  CheckBoxCriteriaChange,
} from "../stores/loginSlice";
import province from "province";
import Swal from "sweetalert2";

const $ = window.$;
export const ProfileSetting = (props) => {
  const [customerInfo, searchCriteria, criteriaList, submitFavEnable] = useSelector((state) => [
    state.login.customerInfo,
    state.login.searchCriteria,
    state.login.criteriaList,
    state.login.submitFavEnable,
  ]);
  const [submitEnable, setSubmitEnable] = useState(true);
  const [deleteIndex, setDeleteIndex] = useState(false);
  const [showFavPop, setShowFavPop] = useState(false);

  const formConfig = {
    type: "inline",
    preloader: false,
    focus: "#name",
  };

  const dispatch = useDispatch();
  const validateField = ["fullName", "phone"];

  const swalDeleteButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn-green btn-confirm",
      cancelButton: "btn-red btn-cancel",
      popup: "mfp-content white-popup icw",
      actions: "mt-0",
    },
    buttonsStyling: false,
  });

  const swalAlertButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn-green btn-confirm",
      cancelButton: "btn-red btn-cancel",
      popup: "mfp-content white-popup icw",
      //   actions: 'mt-0'
    },
    buttonsStyling: false,
  });

  useEffect(() => {
    // // Data Test
    // dispatch(addObjToCriteriaList({
    //     customerSubscribeId: "win guid",
    //     criteriaName: "forTest",
    //     province: "81",
    //     district: "8102",
    //     subDistrict: "810201",
    //     propertyType: "01,02,03",
    //     rangePrice: "0,1000000",
    //     areaRange: "400",
    //     useableAreaRange: "30,100",
    // }));
    dispatch(searchCriteriaListChange({ field: "province", value: province }));
  }, []);

  // console.log("criteriaList", criteriaList);
  // console.log("searchCriteria", searchCriteria);

  function OnRadioCheck(fieldName, value, group) {
    console.log(fieldName, value, group);
    dispatch(CheckBoxCriteriaChange({ fieldName, value, group }));
    dispatch(searchCriteriaValidate());
  }

  function OnSearchDataChange(payload) {
    console.log(payload);
    const field = payload.field;
    if (field === "province") {
      const list = searchCriteria[field].option.find((x) => x.value == payload.value);

      OnsearchListChange({ field: "district", value: list.child });
      OnsearchListChange({ field: "subDistrict", value: [] });
    } else if (field === "district") {
      const list = searchCriteria[field].option.find((x) => x.value == payload.value);

      OnsearchListChange({ field: "subDistrict", value: list.child });
    }
    // else if (field === "criteriaName") {
    //     payload.value = replaceStrThaiEngWithSpace(payload.value);
    // }
    dispatch(searchCriteriaDataChange(payload));
    dispatch(searchCriteriaValidate());
  }

  function OnsearchListChange(payload) {
    dispatch(searchCriteriaListChange(payload));
  }

  function IonRangeDataChange(fieldName, from, to) {
    const payload = valueRangeMaxMin(fieldName, from, to);
    console.log(fieldName, payload.value);
    dispatch(searchCriteriaIonRangeChange(payload));
  }

  function RangeInputDataChange(fieldName, from, to) {
    const payload = valueRangeMaxMin(fieldName, from, to);
    console.log(fieldName, payload.value);
    dispatch(searchCriteriaIonRangeChange(payload));
    dispatch(updateCriteriaIonRange({ fieldName }));
  }

  function handleChangeCheckBoxCusInfo(e, field) {
    dispatch(formsCusInfoDataChange({ field: field, value: e.target.checked }));
  }

  const FavTableRowList = (props) => {
    function EditDataRow(index) {
      dispatch(ClearSearchCriteria());
      dispatch(fillFromObjCriteriaList({ index: index }));
      dispatch(searchCriteriaValidate());

      OpenAddPopUp();
    }
    function DeleteDataRow(index) {
      //   setDeleteIndex(index);
      //OpenDeletePopUp();
      DeleteSwal(index);
    }

    function DeleteSwal(index) {
      swalDeleteButtons
        .fire({
          html: `
            <div class="box-delete">
                <i class="ic-npa ic-delete" style="font-size: 2em;"></i>
                <div class="title-delete">ยืนยันลบข้อมูลการตั้งค่า</div>
            </div>
            `,
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            CallApiDelete(index);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            //   swalWithBootstrapButtons.fire({
            //     title: "Cancelled",
            //     text: "Your imaginary file is safe :)",
            //     icon: "error"
            //   });
          }
        });
    }

    const result = props.list.map((obj, index) => {
      return (
        <tr key={`FavTableRowList-${index}`}>
          <td>{`${index + 1}. ${obj.criteriaName.value}`}</td>
          <td>
            <div className="action action-edit" onClick={(e) => EditDataRow(index)}>
              <i className="ic-npa ic-edit"></i>
              <span>แก้ไข</span>
            </div>
            <div className="line"></div>
            <div className="action action-delete" onClick={(e) => DeleteDataRow(index)}>
              <i className="ic-npa ic-delete"></i>
              <span>ลบ</span>
            </div>
          </td>
        </tr>
      );
    });
    return result;
  };

  function OpenAddPopUp() {
    setShowFavPop(true);

    // const favoritePoppup = $('#favorite-popup');

    // if ($.magnificPopup) {
    //     $.magnificPopup.open({
    //         items: [
    //             {
    //                 src: favoritePoppup
    //             }
    //         ],
    //         type: "inline",
    //         overflowY: "scroll",
    //         closeMarkup: '<button type="button" class="mfp-close"><i class="ic-npa ic-npa-icon-plus"></i></button>',
    //         autoFocusLast: false,
    //         fixedContentPos: true,
    //     })
    // }
  }

  function OpenDeletePopUp() {
    const favoritePoppup = $("#delete-favorite-popup");

    if ($.magnificPopup) {
      $.magnificPopup.open({
        items: [
          {
            src: favoritePoppup,
          },
        ],
        type: "inline",
        overflowY: "scroll",
        closeMarkup:
          '<button type="button" class="mfp-close"><i class="ic-npa ic-npa-icon-plus"></i></button>',
        autoFocusLast: false,
        fixedContentPos: true,
      });
    }
  }

  function CancelDelete(e) {
    e.preventDefault();
    $.magnificPopup.close();
  }

  function ConfirmDelete(e) {
    e?.preventDefault();
    $.magnificPopup.close();
    var customerSubscribeId = criteriaList[deleteIndex].customerSubscribeId.value;
    console.log("delete", customerSubscribeId);

    const objRequest = {
      CustomerSubscribeId: customerSubscribeId,
      CriteriaName: "",
      PropertyTypes: "",
      Frequency: "",
    };

    kloader();

    postApiDataAsync({
      urlPath: "/DeleteSubscribe",
      objRequest: addToken(objRequest),
    })
      .then((data) => {
        console.log("Delete Success", data);
        dispatch(removeObjInCriteriaList({ index: deleteIndex }));
      })
      .catch(function (error) {
        console.log(error);
        switch (error.ErrorCode) {
          case "ErrorCode":
          default:
            props.showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        kloader();
      });
  }

  function CallApiDelete(index) {
    var customerSubscribeId = criteriaList[index].customerSubscribeId.value;
    console.log("delete", customerSubscribeId);

    const objRequest = {
      CustomerSubscribeId: customerSubscribeId,
      CriteriaName: "",
      PropertyTypes: "",
      Frequency: "",
    };

    kloader();

    postApiDataAsync({
      urlPath: "/DeleteSubscribe",
      objRequest: addToken(objRequest),
    })
      .then((data) => {
        dispatch(removeObjInCriteriaList({ index: index }));
        swalAlertButtons.fire({
          title: "สำเร็จ",
          icon: "success",
        });
      })
      .catch(function (error) {
        console.log(error);
        switch (error.ErrorCode) {
          case "ErrorCode":
          default:
            props.showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        kloader();
      });
  }

  function CreateNewFav(e) {
    e.preventDefault();
    dispatch(ClearSearchCriteria());
    OpenAddPopUp();
  }

  function SaveFav(e) {
    e.preventDefault();
    const validateField = ["criteriaName", "propertyType", "frequency"];
    const validates = validateField.map((x) => {
      let errMsg = searchCriteria[x].value ? "" : "กรุณาระบุข้อมูล";
      if (errMsg) {
        dispatch(searchCriteriaValidateChange({ field: x, errorMessage: errMsg }));
      }
      const result = searchCriteria[x].value && !errMsg;
      return result;
    });
    const valid = validates.every((c) => c);

    if (!valid) {
      return;
    }

    console.log(`SaveFav customerSubscribeId : [${searchCriteria.customerSubscribeId.value}]`);

    const rangePrice = getRangeValue(searchCriteria.rangePrice);
    const areaRange = getRangeValue(searchCriteria.areaRange);
    const useableAreaRange = getRangeValue(searchCriteria.useableAreaRange);

    const objRequest = {
      CustomerSubscribeId: searchCriteria.customerSubscribeId.value,
      CriteriaName: searchCriteria.criteriaName.value,
      PropertyTypes: searchCriteria.propertyType.value,
      Province: searchCriteria.province.value ? searchCriteria.province.value : null,
      Amphur: searchCriteria.district.value ? searchCriteria.district.value : null,
      Tambon: searchCriteria.subDistrict.value ? searchCriteria.subDistrict.value : null,
      MinPrice: rangePrice.min,
      MaxPrice: rangePrice.max,
      MinArea: areaRange.min,
      MaxArea: areaRange.max,
      MinUseableArea: useableAreaRange.min,
      MaxUseableArea: useableAreaRange.max,
      Frequency: searchCriteria.frequency.value,
    };

    kloader();

    postApiDataAsync({
      urlPath: "/SaveSubscribe",
      objRequest: addToken(objRequest),
    })
      .then((data) => {
        console.log("Save Success", data);
        var temp = { ...objRequest };
        temp.CustomerSubscribeId = data.CustomerSubscribeId;
        dispatch(addObjToCriteriaList(mtCustomerSubscribeRequestToPayload(temp)));
        $.magnificPopup.close();
        swalAlertButtons.fire({
          title: "สำเร็จ",
          icon: "success",
        });
      })
      .catch(function (error) {
        $.magnificPopup.close();
        console.log(error);
        switch (error.ErrorCode) {
          case "ErrorCode":
          default:
            props.showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        kloader();
        setShowFavPop(false);
      });
  }

  function SaveProfileClick(e) {
    console.log("SaveProfileClick");

    const objRequest = {
      Fullname: customerInfo.fullName.value,
      Telno: customerInfo.phone.value,
      Email: customerInfo.email.value,
      IsActive: customerInfo.IsActive.value,
    };

    kloader();

    postApiDataAsync({
      urlPath: "/UpdateCustomer",
      objRequest: addToken(objRequest),
    })
      .then((data) => {
        console.log("Save Success", data);
      })
      .catch(function (error) {
        console.log(error);
        switch (error.ErrorCode) {
          case "ErrorCode":
          default:
            props.showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        kloader();
      });
  }

  function LogoutClick(e) {
    location.reload(true);
  }

  function addToken(obj) {
    return {
      request: {
        token: customerInfo.token.value,
        ...obj,
      },
    };
  }

  function OnUnsubscribe() {
    // unsubscribe in setting page click

    // go to profilesettingpage
    new bootstrap.Tab($("ul.profile-nav li:nth-child(2) a")).show();
    return;
    kloader();
    postApiDataAsync({
      urlPath: "/CustomerSetSubscribe",
      objRequest: addToken({
        SetSubscribe: false,
      }),
    })
      .then((data) => {
        console.log("Save Success", data);
      })
      .catch(function (error) {
        console.log(error);
        switch (error.ErrorCode) {
          case "ErrorCode":
          default:
            props.showPop(error.ErrorMessage);
            break;
        }
      })
      .then(() => {
        dispatch(formsCusInfoDataChange({ field: "IsActive", value: false }));
        kloader();
      });
  }

  return (
    <>
      <div className="container container-medium">
        <div className="profile-nav-wrap">
          <ul className="nav profile-nav" role="tablist">
            <li className="nav-item" role="tab">
              <a
                href="#"
                className="nav-link active"
                data-bs-target="#setting-tabs"
                data-bs-toggle="pill"
                aria-selected="true"
              >
                <i className="ic-npa ic-setting"></i>
                <span>ข้อมูลการตั้งค่า</span>
              </a>
            </li>
            <li className="nav-item" role="tab">
              <a
                href="#"
                className="nav-link"
                data-bs-target="#profile-tabs"
                data-bs-toggle="pill"
                aria-selected="false"
              >
                <i className="ic-npa ic-profile"></i>
                <span>ประวัติ</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">
          <div id="setting-tabs" className="tab-pane fade show active" role="tabpanel">
            <div className={classnames(["wrap-content-table", { hide: criteriaList.length <= 0 }])}>
              <div className="content-table">
                <div className="box-table">
                  <table id="table-detail">
                    <thead>
                      <tr>
                        <th>ตั้งค่าแจ้งเตือน</th>
                        <th>ดำเนินการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <FavTableRowList list={criteriaList} />
                      <tr className="table-box-btn">
                        <td colSpan="2" className="last-row">
                          <button className="btn-plus favorite-popup-toggle" onClick={CreateNewFav}>
                            <span className="box-icon">
                              <i className="ic-npa ic-npa-icon-plus"></i>
                            </span>
                            <span>&nbsp;สร้างใหม่</span>
                          </button>
                          <div className="wrapper-link">
                            <a href={void 0} onClick={OnUnsubscribe} className="link-cancle">
                              ยกเลิกการรับข่าวสารทั้งหมด
                            </a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <button
                className="btn-plus show-xs"
                style={{ margin: "10px auto" }}
                onClick={CreateNewFav}
              >
                <span className="box-icon">
                  <i className="ic-npa ic-npa-icon-plus"></i>
                </span>
                <span>&nbsp;สร้างใหม่</span>
              </button>
              <div className="wrapper-link wrapper-link-show-mobile">
                <a href={void 0} onClick={OnUnsubscribe} className="link-cancle">
                  ยกเลิกการรับข่าวสารทั้งหมด
                </a>
              </div>
            </div>

            <div className={classnames(["not-found-wrapper", { hide: criteriaList.length > 0 }])}>
              <div className="content content-not-found">
                <div className="box-ic-not-found">
                  <i className="ic-npa ic-not-found"></i>
                </div>
                <h2>ไม่พบข้อมูลการตั้งค่า</h2>
                <button className="btn-plus green" onClick={CreateNewFav}>
                  <span className="box-icon">
                    <i className="ic-npa ic-npa-icon-plus"></i>
                  </span>
                  <span>เริ่มตั้งค่า</span>
                </button>
              </div>
            </div>
          </div>

          <div id="profile-tabs" className="tab-pane fade" role="tabpanel">
            <div className="content">
              <h1>แก้ไขข้อมูลส่วนตัว</h1>
              <div className="inner-content">
                <LoginInputField
                  {...customerInfo.fullName}
                  validateField={validateField}
                  setSubmitEnable={setSubmitEnable}
                />
                <LoginInputField
                  {...customerInfo.phone}
                  validateField={validateField}
                  setSubmitEnable={setSubmitEnable}
                />
                <div className="wrap-input disable">
                  <div className="label-input">อีเมล</div>
                  <div className="box-input">
                    <input
                      type="text"
                      className="input input-email"
                      value={customerInfo.email.value}
                      readOnly
                    />
                  </div>
                </div>
                <div className="wrapper-link">
                  <label className="link-accept">
                    <span className="text-accept">ต้องการรับข้อมูลข่าวสารทรัพย์ตรงใจ</span>
                    <input
                      type="checkbox"
                      checked={customerInfo.IsActive.value}
                      onChange={(e) => handleChangeCheckBoxCusInfo(e, "IsActive")}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="box-btn">
                  <a
                    href={void 0}
                    onClick={(e) => SaveProfileClick(e)}
                    className={classnames(["btn-green", { disable: !submitEnable }])}
                  >
                    บันทึก
                  </a>
                  <a href={void 0} onClick={(e) => LogoutClick(e)} className="btn-logout">
                    <i className="ic-npa ic-logout"></i>
                    <span>ออกจากระบบ</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="delete-favorite-popup" className="mfp-hide white-popup icw">
        <div className="box-delete">
          <i className="ic-npa ic-delete"></i>
          <div className="title-delete">ยืนยันลบข้อมูลการตั้งค่า</div>
        </div>
        <div className="box-btn">
          <a href={void 0} onClick={(e) => CancelDelete(e)} className="btn-red btn-cancel">
            ยกเลิก
          </a>
          <a href={void 0} onClick={(e) => ConfirmDelete(e)} className="btn-green btn-confirm">
            ยืนยัน
          </a>
        </div>
      </div>
      {showFavPop && (
        <>
          <div className="myPopUpBg"></div>
          <div className="myPopUpWrap">
            <div className="myPopUpContainer">
              <div className="myPopUpContent">
                <div id="favorite-popup" className="white-popup icw">
                  <div>
                    <div className="box-content">
                      <div className="title-popup">ลงทะเบียนเพื่อรับอีเมลทรัพย์มือสองแนะนำ</div>
                      <div className="sub-title-popup">
                        กรอกรายละเอียดทรัพย์
                        <br className="show-xs" />
                        และทำเลที่สนใจ
                      </div>
                      <div className="inner-content">
                        <div className="wrap-input">
                          <div className="label-input">
                            ตั้งชื่อรายการแจ้งเตือน<span className="c-red">*</span>
                          </div>
                          <div className="box-input">
                            <input
                              type="text"
                              className="input"
                              placeholder="กรอกตั้งชื่อการแจ้งเตือน"
                              value={searchCriteria.criteriaName.value}
                              onChange={(e) => {
                                console.log(e);
                                OnSearchDataChange({
                                  field: "criteriaName",
                                  value: e.target.value,
                                });
                              }}
                            />
                          </div>
                          <div className="valid-msg">กรอกตั้งชื่อการแจ้งเตือน</div>
                        </div>

                        <div className="wrap-input">
                          <div className="label-input">
                            ประเภททรัพย์<span className="c-red">*</span>
                          </div>
                          <div className="wrap-asset">
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.housetype}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.land}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.townhouse}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.condo}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.commercialbuilding}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.warehouse}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.factory}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.apartment}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.office}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                            <div className="asset-radio">
                              <CheckBoxIonInput
                                {...searchCriteria.propertyType.resort}
                                OnformsDataChange={OnRadioCheck}
                              />
                            </div>
                          </div>
                          <div className="valid-msg">กรุณาระบุประเภททรัพย์</div>
                        </div>
                        <div className="wrap-input">
                          <div className="label-input">ทำเลที่ตั้ง</div>
                          <div className="select-field mb-3">
                            <SelectList
                              id="province"
                              {...searchCriteria.province}
                              OnformsDataChange={OnSearchDataChange}
                            />
                          </div>
                          <div className="row">
                            <div className="col-6 margin-15-xs" style={{ paddingRight: "5px" }}>
                              <div className="select-field">
                                <SelectList
                                  id="district"
                                  {...searchCriteria.district}
                                  OnformsDataChange={OnSearchDataChange}
                                />
                              </div>
                            </div>
                            <div className="col-6" style={{ paddingLeft: "5px" }}>
                              <div className="select-field">
                                <SelectList
                                  id="sub-district"
                                  {...searchCriteria.subDistrict}
                                  OnformsDataChange={OnSearchDataChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="wrap-input">
                          <div className="label-input">ช่วงราคา (บาท)</div>
                          <div className="row">
                            <div className="col-6" style={{ paddingRight: "5px" }}>
                              <RangeInput
                                {...searchCriteria.rangePrice}
                                OnformsDataChange={RangeInputDataChange}
                              />
                            </div>
                            <div className="col-6" style={{ paddingLeft: "5px" }}>
                              <IonRange
                                {...searchCriteria.rangePrice}
                                OnformsDataChange={IonRangeDataChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="wrap-input">
                          <div className="label-input">เนื้อที่ (ตร.ว.)</div>
                          <div className="row">
                            <div className="col-6" style={{ paddingRight: "5px" }}>
                              <RangeInput
                                {...searchCriteria.areaRange}
                                OnformsDataChange={RangeInputDataChange}
                              />
                            </div>
                            <div className="col-6" style={{ paddingLeft: "5px" }}>
                              <IonRange
                                {...searchCriteria.areaRange}
                                OnformsDataChange={IonRangeDataChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="wrap-input">
                          <div className="label-input">พื้นที่ใช้สอย (ตร.ม.)</div>
                          <div className="row">
                            <div className="col-6" style={{ paddingRight: "5px" }}>
                              <RangeInput
                                {...searchCriteria.useableAreaRange}
                                OnformsDataChange={RangeInputDataChange}
                              />
                            </div>
                            <div className="col-6" style={{ paddingLeft: "5px" }}>
                              <IonRange
                                {...searchCriteria.useableAreaRange}
                                OnformsDataChange={IonRangeDataChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="wrap-input">
                          <div className="label-input">
                            ความถี่ในการรับอีเมลรายการทรัพย์แนะนำ<span className="c-red">*</span>
                          </div>
                          <div className="wrap-radio">
                            <div
                              className="box-input"
                              onClick={(e) =>
                                OnSearchDataChange({ field: "frequency", value: "D" })
                              }
                            >
                              <div className="_radio">
                                <input
                                  type="radio"
                                  className="radio"
                                  name="frequency-email"
                                  readOnly
                                  checked={searchCriteria.frequency.value === "D"}
                                />
                              </div>
                              <label htmlFor="daily-email">รายวัน</label>
                            </div>
                            <div
                              className="box-input"
                              onClick={(e) =>
                                OnSearchDataChange({ field: "frequency", value: "W" })
                              }
                            >
                              <div className="_radio">
                                <input
                                  type="radio"
                                  className="radio"
                                  name="frequency-email"
                                  readOnly
                                  checked={searchCriteria.frequency.value === "W"}
                                />
                              </div>
                              <label htmlFor="weekly-email">รายสัปดาห์</label>
                            </div>
                            <div
                              className="box-input"
                              onClick={(e) =>
                                OnSearchDataChange({ field: "frequency", value: "M" })
                              }
                            >
                              <div className="_radio">
                                <input
                                  type="radio"
                                  className="radio"
                                  name="frequency-email"
                                  readOnly
                                  checked={searchCriteria.frequency.value === "M"}
                                />
                              </div>
                              <label htmlFor="monthly-email">รายเดือน</label>
                            </div>
                          </div>
                          <div className="valid-msg">กรุณากรอกความถี่ในการรับอีเมล</div>
                        </div>
                      </div>
                    </div>
                    <div className="box-btn">
                      <a
                        href={void 0}
                        onClick={(e) => SaveFav(e)}
                        className={classnames([
                          "btn-green btn-confirm mousePointer",
                          { disable: !submitFavEnable.value },
                        ])}
                      >
                        บันทึก
                      </a>
                    </div>
                  </div>
                  <button type="button" className="btn-close" onClick={(e) => setShowFavPop(false)}>
                    <i className="ic-npa ic-npa-icon-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* <div id="favorite-popup" className="mfp-hide white-popup icw">
            <div>
                <div className="box-content">
                    <div className="title-popup">ลงทะเบียนเพื่อรับอีเมลทรัพย์มือสองแนะนำ</div>
                    <div className="sub-title-popup">กรอกรายละเอียดทรัพย์<br className="show-xs" />และทำเลที่สนใจ</div>
                    <div className="inner-content">
                        <div className="wrap-input">
                            <div className="label-input">ตั้งชื่อรายการแจ้งเตือน<span className="c-red">*</span></div>
                            <div className="box-input">
                                <input type="text" className="input" placeholder="กรอกตั้งชื่อการแจ้งเตือน" value={searchCriteria.criteriaName.value}
                                    onChange={e => { console.log(e); OnSearchDataChange({ field: 'criteriaName', value: e.target.value }) }}
                                />

                            </div>
                            <div className="valid-msg">กรอกตั้งชื่อการแจ้งเตือน</div>
                        </div>

                        <div className="wrap-input">
                            <div className="label-input">ประเภททรัพย์<span className="c-red">*</span></div>
                            <div className="wrap-asset">
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.housetype} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.land} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.townhouse} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.condo} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.commercialbuilding} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.warehouse} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.factory} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.apartment} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.office} OnformsDataChange={OnRadioCheck} />
                                </div>
                                <div className="asset-radio">
                                    <CheckBoxIonInput {...searchCriteria.propertyType.resort} OnformsDataChange={OnRadioCheck} />
                                </div>
                            </div>
                            <div className="valid-msg">กรุณาระบุประเภททรัพย์</div>
                        </div>
                        <div className="wrap-input">
                            <div className="label-input">ทำเลที่ตั้ง</div>
                            <div className="select-field mb-3">
                                <SelectList id="province" {...searchCriteria.province} OnformsDataChange={OnSearchDataChange} />
                            </div>
                            <div className="row">
                                <div className="col-6 margin-15-xs" style={{ paddingRight: "5px" }}>
                                    <div className="select-field">
                                        <SelectList id="district" {...searchCriteria.district} OnformsDataChange={OnSearchDataChange} />
                                    </div>
                                </div>
                                <div className="col-6" style={{ paddingLeft: "5px" }}>
                                    <div className="select-field">
                                        <SelectList id="sub-district" {...searchCriteria.subDistrict} OnformsDataChange={OnSearchDataChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrap-input">
                            <div className="label-input">ช่วงราคา (บาท)</div>
                            <div className="row">
                                <div className="col-6" style={{ paddingRight: "5px" }}>
                                    <RangeInput {...searchCriteria.rangePrice} OnformsDataChange={RangeInputDataChange} />
                                </div>
                                <div className="col-6" style={{ paddingLeft: "5px" }}>
                                    <IonRange {...searchCriteria.rangePrice} OnformsDataChange={IonRangeDataChange} />
                                </div>
                            </div>
                        </div>
                        <div className="wrap-input">
                            <div className="label-input">เนื้อที่ (ตร.ว.)</div>
                            <div className="row">
                                <div className="col-6" style={{ paddingRight: "5px" }}>
                                    <RangeInput {...searchCriteria.areaRange} OnformsDataChange={RangeInputDataChange} />
                                </div>
                                <div className="col-6" style={{ paddingLeft: "5px" }}>
                                    <IonRange {...searchCriteria.areaRange} OnformsDataChange={IonRangeDataChange} />
                                </div>
                            </div>
                        </div>
                        <div className="wrap-input">
                            <div className="label-input">พื้นที่ใช้สอย (ตร.ม.)</div>
                            <div className="row">
                                <div className="col-6" style={{ paddingRight: "5px" }}>
                                    <RangeInput {...searchCriteria.useableAreaRange} OnformsDataChange={RangeInputDataChange} />
                                </div>
                                <div className="col-6" style={{ paddingLeft: "5px" }}>
                                    <IonRange {...searchCriteria.useableAreaRange} OnformsDataChange={IonRangeDataChange} />
                                </div>
                            </div>
                        </div>
                        <div className="wrap-input">
                            <div className="label-input">ความถี่ในการรับอีเมลรายการทรัพย์แนะนำ<span className="c-red">*</span></div>
                            <div className="wrap-radio">
                                <div className="box-input" onClick={e => OnSearchDataChange({ field: "frequency", value: "D" })}>
                                    <div className="_radio">
                                        <input type="radio" className="radio" name="frequency-email" readOnly checked={searchCriteria.frequency.value === "D"} />
                                    </div>
                                    <label htmlFor="daily-email">รายวัน</label>
                                </div>
                                <div className="box-input" onClick={e => OnSearchDataChange({ field: "frequency", value: "W" })}>
                                    <div className="_radio">
                                        <input type="radio" className="radio" name="frequency-email" readOnly checked={searchCriteria.frequency.value === "W"} />
                                    </div>
                                    <label htmlFor="weekly-email">รายสัปดาห์</label>
                                </div>
                                <div className="box-input" onClick={e => OnSearchDataChange({ field: "frequency", value: "M" })}>
                                    <div className="_radio">
                                        <input type="radio" className="radio" name="frequency-email" readOnly checked={searchCriteria.frequency.value === "M"} />
                                    </div>
                                    <label htmlFor="monthly-email">รายเดือน</label>
                                </div>
                            </div>
                            <div className="valid-msg">กรุณากรอกความถี่ในการรับอีเมล</div>
                        </div>
                    </div>
                </div>
                <div className="box-btn">
                    <a href={void (0)} onClick={e => SaveFav(e)} className={classnames(["btn-green btn-confirm mousePointer", { "disable": !submitFavEnable.value }])}>บันทึก</a>
                </div>
            </div>
        </div> */}
    </>
  );
};

function getRangeValue(item) {
  let value = item.value;
  let from = "0";
  let to = "0";

  if (!value) {
    from = null;
    to = null;
  } else if (value.indexOf("สูงสุด") !== -1) {
    to = value;
  } else if (value.indexOf("เริ่มต้น") !== -1) {
    from = value;
    to = null;
  } else {
    from = value.split("-")[0];
    to = value.split("-")[1];
  }
  return { min: from !== null ? unitToValue(from) : from, max: to !== null ? unitToValue(to) : to };
}
